import { useLazyQuery } from '@apollo/client';
import React, { useEffect } from 'react'
import { GET_SCRAP_EVENT_ERROR } from '../../../features/ErrorDashboard/api/ErrorQuery';
import ToasterWithMessage from '../toaster';
import { CircularProgress } from '@mui/material';
import styles from './StripePaymentsError.module.css';
import AppTable from '../table/AppTable';
import moment from 'moment';
import {  formatDates } from '../../../helper';



const ScrapeEventError = (props: any) => {
  const {
          rowsPerPageScrape,
          currentPageScrape,
          setCurrentPageScrape,
          checking,
          setChecking,
          scrapeEventErrorList,
          setScrapeEventErrorList,
          columnTypes,
          setColumnTypes,
          sortType,
          setSortType,
          selected,
          setSelected,
          datesForApiCall,
          selectedStartDate,
          selectedEndDate,
          GenerateScrapeEventErrorHeadCells,
          handleChangeRowsPerPageForScrape,
          handlePageChangeScrape
  } = props;
  const {error} = ToasterWithMessage();
  const [getScrapeEventErrorData,{loading}] = useLazyQuery(GET_SCRAP_EVENT_ERROR,{
    fetchPolicy: 'no-cache',
    onCompleted: (stripeData) => {
        setScrapeEventErrorList(stripeData);
    },
    onError: (err) => {
      error("Something went wrong while fetching error data!")
    }
  })


  const callStripePaymentsErrorApi = () => {
    const startdateForScrape = datesForApiCall.fromdate;
    const enddateForScrape = datesForApiCall.enddate;
    // const payloadEndDateForStripe = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
    const formattedDates = formatDates(startdateForScrape, enddateForScrape);
    if(moment(startdateForScrape).isSameOrBefore(enddateForScrape,'day')){
      getScrapeEventErrorData({
          variables: {
            pageSize: rowsPerPageScrape,
            pageNumber: (currentPageScrape - 1) * rowsPerPageScrape,
            order_by: { [columnTypes]: sortType}, 
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate
          }
        })
        return;
    }else {
        // error("Fromdate must be greater than todate");
        return;
    }
  };
  
  useEffect(() => {
    callStripePaymentsErrorApi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedStartDate,
     selectedEndDate,
     sortType,
     columnTypes,
     rowsPerPageScrape,
     currentPageScrape
    ]);


  return (
    <>
      {
        loading
      ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
      :
      <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPageForScrape}
        handlePageChange={handlePageChangeScrape}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPageScrape}
        setCurrentPage={setCurrentPageScrape}
        currentPage={currentPageScrape}
        list={scrapeEventErrorList}
        // list={dummyerrorDataForScrape}
        tableTitle="scrapEventError"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateScrapeEventErrorHeadCells}
      />
      }
    </>
  )
}

export default ScrapeEventError